import { z } from "zod";

export const WarrantySchema = z.object({
  wid: z.number(),
  wtitle: z.string().nullable(),
  wlterm: z.number().default(0),
  wmterm: z.number().default(0),
  wdesc: z.string().nullable(),
  wview: z.string().nullable(),
  wexptype: z.string().nullable(),
  wexpamt: z.string().nullable(),
  wservices: z.string().nullable(),
});

export type Warranty = z.infer<typeof WarrantySchema>; 